export default __webpack_public_path__ + "static/media/CapaClose.a404916f.svg";